import { createSelector } from "reselect"
import { get, chain, map, reduce, set } from "lodash"
import moment from "moment"
import { aggregateFactorsSumBy } from "helpers/factorClassification/index"
import { getMustAggregateFactors } from "modules/portfolio-root/selectors/portfolios"
import { getModelFactorsClassification } from "selectors/modelMetadata"
import { getSelectedMetric } from "./metrics"
import { getIsActive, getPositionSets } from "."
import { canSegmentBeDisplayed } from "../helpers"

function mapAggregatedFactors(data, mustAggregateFactors, factorsClassification) {
  return map(data, date => {
    let factors = get(date, "attribution.factors")
    if (!mustAggregateFactors || !factors) {
      return date
    }

    factors = aggregateFactorsSumBy(factorsClassification, factors, "value")
    return chain(date)
      .cloneDeep()
      .set("attribution.factors", factors)
      .value()
  })
}

const getRawData0 = state => get(state, "global.data.compareRiskPositionSet0.data.model.simulation.risk")
const getRawData1 = state => get(state, "global.data.compareRiskPositionSet1.data.model.simulation.risk")
const getRawData2 = state => get(state, "global.data.compareRiskPositionSet2.data.model.simulation.risk")
const getRawData3 = state => get(state, "global.data.compareRiskPositionSet3.data.model.simulation.risk")
const getRawData4 = state => get(state, "global.data.compareRiskPositionSet4.data.model.simulation.risk")

export const getData0 = createSelector([getRawData0, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData1 = createSelector([getRawData1, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData2 = createSelector([getRawData2, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData3 = createSelector([getRawData3, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)
export const getData4 = createSelector([getRawData4, getMustAggregateFactors, getModelFactorsClassification], mapAggregatedFactors)

function getDataMap({ value: selector }, data) {
  if (!data) {
    return null
  }

  return chain(data)
    .keyBy("date")
    .mapValues(selector)
    .value()
}

const getDataMap1 = createSelector([getSelectedMetric, getData1], getDataMap)
const getDataMap2 = createSelector([getSelectedMetric, getData2], getDataMap)
const getDataMap3 = createSelector([getSelectedMetric, getData3], getDataMap)
const getDataMap4 = createSelector([getSelectedMetric, getData4], getDataMap)

export const getData = createSelector(
  [getSelectedMetric, getData0, getDataMap1, getDataMap2, getDataMap3, getDataMap4, getPositionSets, getIsActive],
  ({ value: selector }, data, dataMap1, dataMap2, dataMap3, dataMap4, positionSets, isActive) => map(data, item => ({
    date: moment(item.date),
    0: selector(item),
    ...reduce([dataMap1, dataMap2, dataMap3, dataMap4],
      (allDataMaps, data, index) => set(allDataMaps, index + 1, data && canSegmentBeDisplayed(get(positionSets, index + 1), isActive) ? get(data, item.date, 0) : undefined),
      {}),
  })),
)
